import { Layout } from "../../../components/Layout";
import { Column, Grid, Row } from "carbon-components-react";
import { useLocation } from "react-router-dom";

export default function GooglePay() {
  const { pathname } = useLocation();
  return (
    <>
      <div className="doc-content">
        <h3 className="doc-title">Google Pay ™ </h3>

        <p className="text-in mb-8 black">
          Google Pay™ allows customers to complete payments quickly and securely
          without manually entering card details. Card information is securely
          stored by Google. Transactions are processed by LIBERTY through the
          respective card schemes. To activate Google Pay™, select the Google
          Pay™ option during the onboarding/application process. Once the
          service is approved and enabled on Liberty’s side, we will
          automatically display the Google Pay button in your payment window for
          applicable transactions.
        </p>
        <p className="text-in mb-8 black">
          In addition to the standard payment window, LIBERTY supports native
          Google Pay™ integration, allowing you to embed the payment experience
          directly within your own mobile application or website interfaces.
          Detailed implementation guidelines for native integration will be
          provided in the upcoming technical documentation.
        </p>
        <p className="text-in mb-8 black">
          LIBERTY supports multiple authorization methods for Google Pay™
          transactions, including both PAN-only and cryptogram-based (3D Secure)
          flows. 3D Secure authentication, when required, is automatically
          processed by Liberty as part of the transaction. As certain 3D Secure
          scenarios may require additional customer information (such as the
          billing address), we recommend providing all relevant data when
          initiating the payment request. LIBERTY supports VISA and MasterCard
          transactions from Google Pay. You can use Google Pay for single
          authorizations or for recurring billing authorizations. Enabling
          Google Pay™ is free and can enhance the payment experience for your
          customers, potentially increasing conversion rates.
        </p>
      </div>
    </>
  );
}
